export default __webpack_public_path__ + "static/media/link_3.6a763cfd.png";